


















































































































import { Component, Watch, Mixins } from 'vue-property-decorator'
import moment from 'moment-timezone'
import DateRangePicker from 'buefy-daterange-picker'

// Models
import BeaconModel from '@/_models/BeaconModel'
import WorkRecorderModel from '@/_models/WorkRecorderModel'
import UserModel from '@/_models/UserModel'

// Common
import NotFound from '@/components/common/NotFound.vue'

// Shared
import FilterDropdown from '@/components/shared/FilterDropdown.vue'
import TablePagination from '@/components/shared/TablePagination.vue'

// Mixins
import DateRangeMixin from '@/components/mixins/DateRangeMixin.vue'
import AnalysisDisplayMixin from '@/components/mixins/AnalysisDisplayMixin.vue'
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'

import { Filter } from '@/_utils/filter'
import { Constant } from '@/_services/constant'

// Chart
import { Plotly } from 'vue-plotly'
import CardModel from '@/_models/CardModel'

@Component({
  components: {
    DateRangePicker,
    Plotly,
    FilterDropdown,
    NotFound,
    TablePagination,
  },
  computed: {},
})
export default class WorkRecorderChart extends Mixins(DateRangeMixin, AnalysisDisplayMixin, TableSortMixin) {
  filterUtilTableSort: any = new Filter('filter_analysis_table_sort')
  dataTableAnalysis: any[] = []
  // data
  filterUtilPage: any = new Filter('filter_analysis_page_')

  numofPage: number = 1
  pageFilters: any = {
    currentPage: 1,
    perPage: 20,
    selectedFilter: 'location_name',
    searchQuery: '',
  }

  get isLoading(): boolean {
    return this.$store.state.analysis.loading
  }

  get fixedDevices(): Array<BeaconModel | CardModel> {
    return [...this.$store.state.beacons.all.items, ...this.$store.state.cards.all.items]
  }

  get filteredfixedDevices() {
    const targetField: string = this.pageFilters.selectedFilter || 'location_name'

    if (!this.fixedDevices) {
      return []
    }

    const fixedDevices = this.fixedDevices.filter((item: any): boolean => {
      return (
        String(item[targetField]).toLowerCase().indexOf(this.pageFilters.searchQuery.toLowerCase()) !== -1
      )
    })

    this.numofPage = Math.ceil(fixedDevices.length / this.pageFilters.perPage)

    return fixedDevices
  }

  get users(): UserModel[] {
    return this.$store.state.users.all.items_raw
  }

  get dataWorkRecorders() {
    const workRecordersData = (this.$store.state.analysis.all.work_recorders as WorkRecorderModel[]) || []
    const mappingResult = {}
    workRecordersData.forEach(item => {
      if (item.u_id && item.s_id && item.b_id) {
        const keyExist = Object.keys(mappingResult)
        const keyMapping = `${item.u_id}-${item.b_id}-${item.s_id}`

        if (keyExist.includes(keyMapping)) {
          mappingResult[keyMapping] = item.tt + mappingResult[keyMapping]
        } else {
          mappingResult[keyMapping] = item.tt
        }
      }
    })

    return mappingResult
  }

  get userColumns(): any[] {
    const columns: any = []
    for (const user of this.users) {
      const tmp1 = {}
      tmp1[user._id] = user.name
      columns.push({
        numeric: true,
        field: user._id,
        label: user.name + (user.san_id ? `(${user.san_id})` : ''),
        color: user.category_color,
      })
    }

    return columns
  }

  get columns(): any[] {
    const columns: any = []
    columns.push({
      sticky: true,
      headerClass: 'is-sticky-column-one',
      cellClass: 'is-sticky-column',
      field: 'location',
      label: this.$t('label.location'),
    })

    columns.push({
      numeric: true,
      field: 'sum',
      label: '合計[min]',
    })

    if (this.$isMobileSize()) {
      return columns
    }

    return columns.concat(this.userColumns)
  }

  @Watch('filteredfixedDevices')
  async filteredfixedDevicesChanged() {
    this.setDataTableAnalysis()
  }

  @Watch('dateRange')
  async dateRangeChanged() {
    const toSave = {
      startDate: this.dateFrom,
      endDate: this.dateTo,
    }

    this.filterUtilDateRange.save(toSave)
    await this.fetchAllAnalysis()
  }

  setDataTableAnalysis() {
    if (
      this.isLoading ||
      !this.users.length ||
      !this.filteredfixedDevices.length ||
      !this.dataWorkRecorders
    ) {
      return []
    }

    const dataRow: any = []
    let index = 0
    for (const fixedDevice of this.filteredfixedDevices) {
      let sum: number = 0
      const tmp: any = {
        rowId: index += 1,
        location: fixedDevice.location_name || '-',
      }

      const isCardFixed = (fixedDevice as CardModel).card_type

      for (const user of this.users) {
        let keyMapped = ''
        if (isCardFixed) {
          keyMapped = `${user._id}-${user.beacon_id}-${(fixedDevice as CardModel).san_id}`
        } else {
          keyMapped = `${user._id}-${(fixedDevice as BeaconModel)._id}-${user.san_id}`
        }
        const value: number = this.dataWorkRecorders[keyMapped] || 0
        tmp[user._id] = value
        sum += value
      }

      tmp.sum = Math.round(sum * 100) / 100
      dataRow.push(tmp)
    }

    this.dataTableAnalysis = dataRow
  }

  async fetchAllAnalysis() {
    if (this.$store.state.all_locations.loading) {
      return
    }

    await this.$store.dispatch('analysis/getAllWorkRecorder', {
      date_from: moment(this.dateRange.startDate).format(this.queryDateFormat),
      date_to: moment(this.dateRange.endDate).format(this.queryDateFormat),
    })

    this.setDataTableAnalysis()
  }

  beforeDestroy() {
    this.saveDaterange()
    this.filterUtilPage.save(this.pageFilters)
  }

  // After page created
  async created() {
    // [Mobile] - Setting to toggle card
    this.tableRef = 'chartTableList'

    this.setChartConfig()
    this.pageFilters = this.filterUtilPage.get(this.pageFilters)
    this.dateRange = this.filterUtilDateRange.get(this.dateRange)

    await this.$store.dispatch('users/getUsersRaw')
    await this.$store.dispatch('beacons/getAll', {
      beacon_type: Constant.BEACON_TYPE_STATIC,
    })

    await this.$store.dispatch('cards/getAll', {
      card_type: Constant.CARD_TYPE_STATIC,
    })

    // await this.fetchAllAnalysis()
  }
}
